<template>
  <div :class="testRegister ? 'auth-form-wrap auth-form-wrap--psytest' : 'rb-auth-form-root'">
    <header v-if="!testRegister" class="rb-auth-top">
      <button
          type="button"
          class="rb-auth-icon-btn"
          :aria-label="$t('authUi.back')"
          @click="handleAuthBack"
      >
        <span aria-hidden="true">›</span>
      </button>
      <img
          class="rb-auth-wordmark"
          src="../../assets/logo/roobroo-wordmark.svg"
          :alt="$t('authUi.brand')"
      >
      <span class="rb-auth-icon-btn rb-auth-top-spacer" aria-hidden="true"></span>
    </header>
    <div :class="testRegister ? 'text-center mt-8' : 'rb-auth-main'">
      <div :class="testRegister ? 'loginBox mt-5 loginBox--psytest' : ''">

        <v-window v-model="authWindow" touchless :class="{ 'rb-auth-window': !testRegister }">
          <v-window-item value="login">
            <form
                v-if="!testRegister"
                class="rb-auth-form"
                :data-mode="authMode"
                novalidate
                @submit.prevent="handleLoginFormSubmit"
            >
              <header>
                <h1 class="rb-auth-title">{{ authMode === 'register' ? $t('authUi.registerTitle') : $t('authUi.loginTitle') }}</h1>
                <p class="rb-auth-lead">{{ authMode === 'register' ? $t('authUi.registerLead') : $t('authUi.loginLead') }}</p>
              </header>
              <p v-if="authMode === 'login'" class="rb-auth-intro">{{ $t('authUi.loginIntro') }}</p>
              <div class="rb-auth-fields">
                <div
                    v-if="authMode === 'register'"
                    class="rb-auth-field"
                    :class="{ 'is-invalid': !!nameError }"
                >
                  <label for="rb-auth-name">{{ $t('authUi.nameLabel') }}</label>
                  <input
                      id="rb-auth-name"
                      v-model="registerFullName"
                      class="rb-auth-control"
                      type="text"
                      name="name"
                      autocomplete="name"
                      maxlength="80"
                      :aria-invalid="!!nameError"
                      @input="nameError = ''"
                  >
                  <p class="rb-auth-hint">{{ $t('authUi.nameHint') }}</p>
                  <p class="rb-auth-err">{{ nameError || $t('authUi.nameError') }}</p>
                </div>
                <div class="rb-auth-field" :class="{ 'is-invalid': !!phoneError }">
                  <label for="rb-auth-phone">{{ $t('authUi.phoneLabel') }}</label>
                  <input
                      id="rb-auth-phone"
                      v-model="loginForm.input"
                      class="rb-auth-control"
                      type="tel"
                      name="phone"
                      inputmode="numeric"
                      autocomplete="tel"
                      maxlength="13"
                      :placeholder="$t('authUi.phonePlaceholder')"
                      :aria-invalid="!!phoneError"
                      @input="phoneError = ''"
                  >
                  <p v-if="authMode === 'login'" class="rb-auth-hint">{{ $t('authUi.phoneHint') }}</p>
                  <p class="rb-auth-err">{{ phoneError || $t('authUi.phoneError') }}</p>
                </div>
                <div
                    v-if="authMode === 'register'"
                    class="rb-auth-field"
                    :class="{ 'is-invalid': !!termsError }"
                >
                  <div class="rb-auth-consent">
                    <input
                        id="rb-auth-terms"
                        v-model="acceptedTerms"
                        type="checkbox"
                        :aria-invalid="!!termsError"
                        @change="termsError = ''"
                    >
                    <label class="rb-auth-consent-copy" for="rb-auth-terms">
                      <button type="button" class="rb-auth-inline-link" @click.stop.prevent="openTerms('terms')">
                        {{ $t('authUi.termsUse') }}
                      </button>
                      {{ $t('authUi.termsAnd') }}
                      <button type="button" class="rb-auth-inline-link" @click.stop.prevent="openTerms('privacy')">
                        {{ $t('authUi.termsPrivacy') }}
                      </button>
                      {{ $t('authUi.termsAfter') }}
                    </label>
                  </div>
                  <p class="rb-auth-err">{{ termsError || $t('authUi.termsError') }}</p>
                </div>
              </div>
              <div class="rb-auth-actions">
                <button class="rb-auth-submit" type="submit" :disabled="loadingStatus">
                  {{ $t('authUi.submitCode') }}
                </button>
                <p class="rb-auth-switch">
                  <template v-if="authMode === 'login'">
                    {{ $t('authUi.needAccount') }}
                    <button type="button" class="rb-auth-inline-link" @click="setAuthMode('register')">
                      {{ $t('authUi.tabRegister') }}
                    </button>
                  </template>
                  <template v-else>
                    {{ $t('authUi.haveAccount') }}
                    <button type="button" class="rb-auth-inline-link" @click="setAuthMode('login')">
                      {{ $t('authUi.tabLogin') }}
                    </button>
                  </template>
                </p>
                <div class="rb-auth-trust">
                  <p>{{ authMode === 'register' ? $t('authUi.registerTrust') : $t('authUi.loginTrust') }}</p>
                  <p>{{ $t('authUi.familyNote') }}</p>
                </div>
                <p class="rb-auth-status" role="status" aria-live="polite">{{ formStatus }}</p>
              </div>
            </form>
            <div v-else class="authForm" id="login">
              <img
                  src="../../assets/logo/roobroo-logo.png"
                  class="psytest-login-logo"
                  alt=""
              >
              <div class="text-center titleLogin mb-8">
                {{ authTitle || 'ورود/ثبت نام' }}
              </div>
              <v-form class="mt-5 mx-8" ref="loginForm"
                      @submit="handleLoginFormSubmit">
                <v-text-field
                    v-model="loginForm.input"
                    class="mobileInput"
                    outlined
                    prepend-inner-icon="mdi-cellphone"
                    style="border-radius: 8px!important;direction: ltr;"
                    :rules="inputRules"
                    ref="firstFieldRef"
                    :tab_index_number="1"
                    type="tel"
                    :placeholder="$t('signupComponent.phone')"
                    id="mobile"
                ></v-text-field>
                <v-btn type="button" color="#46b1a1" class="white--text loginBtn mt-5 mb-15" elevation="0"
                       @click="login()"
                       :tab_index_number="3"
                       id="loginBtn"
                       :disabled="loadingStatus"
                       style="position: relative;z-index: 10;text-decoration: none">
                  ورود/ثبت نام
                </v-btn>

<!--                <p class="mt-2" style="color: grey;font-size: 15px">-->
<!--                  {{ $t('loginComponent.or') }}-->
<!--                </p>-->
<!--                <div class="loginMethod mt-2 " style="z-index: 999;position:relative;">-->
<!--                  <div class="loginItem" @click="loginBy('google')">-->
<!--                    <div class="titleItem flex-grow-1 font-weight-bold">-->
<!--                      {{ $t('loginComponent.googleLogin') }}-->
<!--                     </div>-->
<!--                    <div class="iconItem  fill-height">-->
<!--                      <img src="../../assets/matchMaking/google.svg" width="30px" alt="">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->


<!--                <v-btn :to="{name:'signin', params: {lang: 'fa'}}" class="mt-5 mb-2" style="color: #6d6d6d;z-index: 9999"-->
<!--                       text-->
<!--                       id="registerBtn">-->
<!--                  {{ $t('loginComponent.noAccount') }}-->
<!--                  <span style="color: #46b1a1" class="font-weight-bold">-->
<!--                  {{ $t('register') }}-->
<!--                </span>-->
<!--                </v-btn>-->
<!--                <v-btn style="position: relative;z-index: 10" color="#46b1a1" text-->
<!--                       @click="authWindow = 'forgetpassword'" id="forgetPasswordBtn">-->
<!--                  {{ $t('loginComponent.forgetPassword.title') }}-->
<!--                </v-btn>-->
              </v-form>
            </div>
          </v-window-item>
          <!--          <v-window-item value="register">-->
          <!--            <div class="authForm text-center" id="register">-->
          <!--              <div class="titleAuthWindow">-->
          <!--                {{ $t('register') }}-->
          <!--              </div>-->
          <!--              <v-form class="mt-12 mx-8" ref="registerForm" @keypress.native.enter="register">-->

          <!--                <v-text-field-->
          <!--                    v-model="registerFrom.email"-->
          <!--                    prepend-inner-icon="mdi-email"-->
          <!--                    :rules="emailRules"-->
          <!--                    ref="firstFieldRef"-->
          <!--                    @keydown.enter.prevent="$refs.secondFieldRef.focus()"-->
          <!--                    :tab_index_number="1"-->
          <!--                    :label="$t('emailLabel')"-->
          <!--                    id-input="emailRegister"-->
          <!--                ></v-text-field>-->
          <!--                <div class="ltrInput">-->
          <!--                  <v-text-field-->
          <!--                      :loader-height="0"-->
          <!--                      style="font-size: 1em"-->
          <!--                      dir="rtl"-->
          <!--                      type="tel"-->
          <!--                      id="phoneRegister"-->
          <!--                      prepend-inner-icon="mdi-cellphone"-->
          <!--                      name="tel"-->
          <!--                      placeholder="+1 555 123 4567"-->
          <!--                      v-model="phone"-->
          <!--                      :rules="phoneRules"-->
          <!--                      :label="$t('signupComponent.phone')"-->
          <!--                  >-->
          <!--                  </v-text-field>-->
          <!--                </div>-->
          <!--                &lt;!&ndash;                <v-text-field&ndash;&gt;-->
          <!--                &lt;!&ndash;                    :rules="passwordRules"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    :type="registerFrom.passwordType"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    v-model="registerFrom.password"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    append-outer-icon="mdi-eye"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    prepend-inner-icon="mdi-lock"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    lable="'sdvsdvdsv'"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    tabindex="2"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    @click:prepend-inner="changePassType"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    id="passwordRegister"&ndash;&gt;-->
          <!--                &lt;!&ndash;                ></v-text-field>&ndash;&gt;-->
          <!--                &lt;!&ndash;                <InputWrapper&ndash;&gt;-->
          <!--                &lt;!&ndash;                    modelkey="password"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    :model="registerFrom" @appendOuterIcon="changePassType($event)"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    :type="registerFrom.passwordType"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    id-input="password"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    tabindex="2"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    append_outer_icon="mdi-eye"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    append-icon="mdi-lock"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    :rules="requiredRules"&ndash;&gt;-->
          <!--                &lt;!&ndash;                    :label="$t('passwordLabel')"/>&ndash;&gt;-->
          <!--                <v-text-field-->
          <!--                    @click:append="changePassType(registerFrom)"-->
          <!--                    v-model="registerFrom.password"-->
          <!--                    :type="registerFrom.passwordType"-->
          <!--                    id-input="password"-->
          <!--                    append-icon="mdi-eye"-->
          <!--                    prepend-inner-icon="mdi-lock"-->
          <!--                    :tab_index_number="2"-->
          <!--                    ref="secondFieldRef"-->
          <!--                    :rules="requiredRules"-->
          <!--                    :label="$t('passwordLabel')"-->
          <!--                ></v-text-field>-->
          <!--                &lt;!&ndash;                <InputWrapper modelkey="password"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              :model="registerFrom"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              @appendOuterIcon="changePassType"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              :type="registerFrom.passwordType"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              id-input="passwordRegister"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              tabindex="2"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              append-icon="mdi-lock"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              append_outer_icon="mdi-eye"&ndash;&gt;-->
          <!--                &lt;!&ndash;                              :rules="passwordRules" prepend_inner_icon="mdi-eye" />&ndash;&gt;-->

          <!--                <v-btn color="#46b1a1" class="white&#45;&#45;text loginBtn mt-5" elevation="0" @click="register"-->
          <!--                       tabindex="3"-->
          <!--                       id="registerSubmit"-->
          <!--                       :disabled="loadingStatus"-->
          <!--                       style="position: relative;z-index: 10">-->
          <!--                  {{ $t('register') }}-->
          <!--                </v-btn>-->
          <!--                <v-btn class="googleBtn mt-4" elevation="0" @click="loginBy('google')" id="googleBtn">-->
          <!--                  <img src="../../assets/matchMaking/google.svg" alt="">-->
          <!--                  {{ $t('matchMaking.registerForm.registerByGoogle') }}-->
          <!--                </v-btn>-->

          <!--                <v-btn class="mt-10 mb-2" id="loginChangePage" style="color: #6d6d6d;z-index: 9999"-->
          <!--                       @click="authWindow = 'login'" text>-->
          <!--                  {{ $t('loginComponent.haveAccount') }}-->
          <!--                  <span style="color: #46b1a1" class="font-weight-bold">-->
          <!--                   {{ $t('loginComponent.login') }}-->
          <!--                </span>-->
          <!--                </v-btn>-->
          <!--              </v-form>-->
          <!--            </div>-->
          <!--          </v-window-item>-->
          <v-window-item value="forgetpassword">
            <div class="authForm" id="forgetpassword">
              <div class="titleAuthWindow">
                {{ $t('loginComponent.forgetPassword.title') }}
              </div>
              <p class="descriptionAuthWindow mt-5 px-10">
                <!--                {{ $t('loginComponent.forgetPassword.subTitle') }}-->
              </p>
              <v-form class="mt-5 mx-8" ref="forgetPassword" @keypress.native.enter="resetPassword">

                <v-text-field
                    v-model="forgetPassword.email"
                    prepend-inner-icon="mdi-email"
                    :rules="emailRules"
                    ref="firstFieldRef"
                    @keydown.enter.prevent="$refs.secondFieldRef.focus()"
                    :tab_index_number="1"
                    :label="$t('emailLabel')"
                    id="emailForget"
                ></v-text-field>

                <v-btn color="#46b1a1" class="white--text loginBtn mt-5" elevation="0" @click="resetPassword"
                       tabindex="3"
                       id="ForgetPasswordAction"
                       :disabled="loadingStatus"
                       style="position: relative;z-index: 10">
                  {{ $t('loginComponent.forgetPassword.action') }}
                </v-btn>
                <v-btn :disabled="loadingStatus" color="#46b1a1" id="returnBtn" text class="mt-4"
                       @click="authWindow = 'login'"
                       style="z-index: 10">
                  {{ $t('return') }}
                </v-btn>
              </v-form>

            </div>
          </v-window-item>
          <v-window-item value="whatsapp-otp">
            <form
                v-if="!testRegister"
                class="rb-auth-form"
                data-mode="verify"
                novalidate
                @submit.prevent="submitWhatsappOtp"
            >
              <header>
                <h1 class="rb-auth-title">{{ $t('authUi.verifyTitle') }}</h1>
                <p class="rb-auth-lead">{{ $t('authUi.verifyLead') }}</p>
              </header>
              <div class="rb-auth-phone" aria-live="polite">
                <p class="rb-auth-phone-label">{{ $t('authUi.phoneSent') }}</p>
                <div class="rb-auth-phone-row">
                  <p class="rb-auth-phone-masked" dir="ltr">{{ maskedPhone }}</p>
                  <button class="rb-auth-change-number" type="button" @click="changePhoneNumber">
                    {{ $t('authUi.changeNumber') }}
                  </button>
                </div>
              </div>
              <div class="rb-auth-otp" :class="{ 'is-invalid': !!otpError }">
                <label id="rb-otp-label">{{ $t('authUi.otpLabel') }}</label>
                <div class="rb-auth-otp-boxes" role="group" aria-labelledby="rb-otp-label">
                  <input
                      v-for="(digit, index) in otpDigits"
                      :key="'otp-' + index"
                      :ref="'otpBox' + index"
                      type="text"
                      inputmode="numeric"
                      autocomplete="one-time-code"
                      maxlength="1"
                      :aria-label="$t('authUi.otpDigit', { n: index + 1 })"
                      :value="digit"
                      :aria-invalid="!!otpError"
                      @input="onOtpInput(index, $event)"
                      @keydown="onOtpKeydown(index, $event)"
                      @paste.prevent="onOtpPaste($event)"
                  >
                </div>
                <p class="rb-auth-hint">{{ $t('authUi.otpHint') }}</p>
                <p class="rb-auth-err">{{ otpError || $t('authUi.otpInvalid') }}</p>
              </div>
              <div class="rb-auth-resend">
                <p class="rb-auth-timer">{{ otpResendLabel }}</p>
                <button
                    class="rb-auth-resend-btn"
                    type="button"
                    :disabled="otpTimer != 0"
                    @click="resendWhatsappOtp"
                >
                  {{ $t('authUi.resend') }}
                </button>
              </div>
              <div class="rb-auth-actions">
                <button class="rb-auth-submit" type="submit" :disabled="loadingStatus">
                  {{ $t('authUi.verifyContinue') }}
                </button>
                <div class="rb-auth-trust">
                  <p>{{ $t('authUi.verifyTrust') }}</p>
                  <p>{{ $t('authUi.familyNote') }}</p>
                </div>
              </div>
            </form>
            <div v-else>
              <img
                  src="../../assets/logo/roobroo-logo.png"
                  class="psytest-login-logo"
                  alt=""
              >
              <p class="mt-2 mb-4 text-center" style="color: #6d6d6d; font-size: 14px;">
                کد تایید پیامک‌شده را وارد کنید
              </p>
              <v-form @submit.prevent="submitWhatsappOtp">
                <div style="width: 70%;margin: 0px auto">
                  <v-otp-input
                      plain
                      type="number"
                      class="my-10"
                      @finish="submitWhatsappOtp"
                      style="direction: ltr;border-color: red"
                      v-model="whatsappOtpCode"
                      length="6"
                  ></v-otp-input>
                </div>
                <v-btn color="#46b1a1" class="white--text loginBtn mt-5" elevation="0"
                       @click="submitWhatsappOtp"
                       :tab_index_number="3"
                       :disabled="loadingStatus"
                       style="position: relative;z-index: 10">
                  {{ $t('loginComponent.login') }}
                </v-btn>
              </v-form>
              <v-btn
                  :disabled="otpTimer != 0"
                  text
                  class="mt-2"
                  style="z-index: 10"
                  color="primary"
                  @click="resendWhatsappOtp"
              >
                {{ otpTimer != 0 ? $t('loginComponent.resendingCode') : 'ارسال دوباره کد' }}
              </v-btn>
              <br>
              {{ otpTimer / 60 | minFilter }}:{{ otpTimer % 60 | secFilter }}
            </div>
          </v-window-item>
          <v-window-item v-if="!testRegister" value="post-otp-password">
            <form
                class="rb-auth-form"
                data-mode="password"
                novalidate
                @submit.prevent="handlePostOtpPasswordFormSubmit"
            >
              <header>
                <h1 class="rb-auth-title">{{ $t('authUi.passwordTitle') }}</h1>
                <p class="rb-auth-lead">{{ $t('authUi.passwordLead') }}</p>
              </header>
              <div class="rb-auth-fields">
                <div class="rb-auth-field" :class="{ 'is-invalid': !!passwordError }">
                  <label for="rb-auth-password">{{ $t('passwordLabel') }}</label>
                  <div class="rb-auth-secret-wrap">
                    <input
                        id="rb-auth-password"
                        v-model="postOtpPassword.password"
                        class="rb-auth-control"
                        :type="postOtpPassword.passwordType"
                        autocomplete="new-password"
                        :aria-invalid="!!passwordError"
                        @input="passwordError = ''"
                    >
                    <button
                        type="button"
                        class="rb-auth-secret-toggle"
                        :aria-label="$t('passwordLabel')"
                        @click="changePassType(postOtpPassword)"
                    >
                      <v-icon small>{{ postOtpPassword.passwordType === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </button>
                  </div>
                  <p class="rb-auth-err">{{ passwordError }}</p>
                </div>
                <div class="rb-auth-field" :class="{ 'is-invalid': !!passwordConfirmError }">
                  <label for="rb-auth-password-confirm">{{ $t('passwordConfirmationLabel') }}</label>
                  <div class="rb-auth-secret-wrap">
                    <input
                        id="rb-auth-password-confirm"
                        v-model="postOtpPassword.password_confirmation"
                        class="rb-auth-control"
                        :type="postOtpPasswordConfirm.passwordType"
                        autocomplete="new-password"
                        :aria-invalid="!!passwordConfirmError"
                        @input="passwordConfirmError = ''"
                    >
                    <button
                        type="button"
                        class="rb-auth-secret-toggle"
                        :aria-label="$t('passwordConfirmationLabel')"
                        @click="changePassType(postOtpPasswordConfirm)"
                    >
                      <v-icon small>{{ postOtpPasswordConfirm.passwordType === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </button>
                  </div>
                  <p class="rb-auth-err">{{ passwordConfirmError }}</p>
                </div>
              </div>
              <div class="rb-auth-actions">
                <button class="rb-auth-submit" type="submit" :disabled="loadingStatus">
                  {{ $t('authUi.passwordSubmit') }}
                </button>
                <div class="rb-auth-trust">
                  <p>{{ $t('authUi.familyNote') }}</p>
                </div>
              </div>
            </form>
          </v-window-item>
        </v-window>
        <img v-if="testRegister" src="../../assets/image/png/login/back.png" class="bottomBack" alt="">
      </div>
    </div>
    <AuthBrandFooter v-if="testRegister" :fixed="footerFixed" />
    <legal-documents-dialog v-model="showTerms" :document-id="legalDocumentId"/>
  </div>
</template>

<script>
/*eslint-disable*/
import InputWrapper from "@/components/Main/Wrapper/InputWrapper";
import AuthBrandFooter from "@/components/Auth/AuthBrandFooter";
import LegalDocumentsDialog from "@/components/legal/LegalDocumentsDialog.vue";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import AuthMixins from "@/mixins/AuthMixins";
import EventsMixins from "@/mixins/EventsMixins";
import globalMixins from "@/mixins/globalMixins";
import {markIntakePending} from "@/intake/intakeState";
import {loginTokenQuery} from "@/router/loginReturn";

/**
 * <h1>Login Form</h1>  <p>this component contain <b>Login & register & forgot password</b> functionality</p>
 *
 * @vue-data {Object} [loginForm] - hold login form data
 * @vue-data {Object} [registerFrom] - hold register form data
 * @vue-data {Object} [forgetPassword] - hold forgot password form data
 * @vue-event  Mounted - check if action query exists in url , render appropriate window
 */

export default {
  components: {InputWrapper, AuthBrandFooter, LegalDocumentsDialog},
  mixins: [AuthMixins, EventsMixins, globalMixins],
  props: {
    inlineAfterLogin: {
      type: Boolean,
      default: false,
    },
    authTitle: {
      type: String,
      default: null,
    },
    testRegister: {
      type: Boolean,
      default: false,
    },
    footerFixed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      whatsappOtpCode: null,
      otpDigits: ['', '', '', '', '', ''],
      authMode: 'login',
      registerFullName: '',
      nameError: '',
      phoneError: '',
      otpError: '',
      termsError: '',
      passwordError: '',
      passwordConfirmError: '',
      formStatus: '',
      acceptedTerms: false,
      showTerms: false,
      legalDocumentId: 'terms',
      loginForm: {
        passwordType: 'password',
        input: null,
        password: null,
      },
      registerFrom: {
        passwordType: 'password',
        email: null,
        password: null,
      },
      forgetPassword: {
        email: null,
      },
      loginOrRegisterMeta: {
        is_new_user: false,
      },
      userJourneyTrkRegistered: false,
      postOtpPassword: {
        password: null,
        password_confirmation: null,
        passwordType: 'password',
      },
      postOtpPasswordConfirm: {
        passwordType: 'password',
      },
      // authWindow: "whatsapp-otp",
      authWindow: "login",
      phone: null,
      otpTimer: 120,
      timer: null,
    }
  },
  filters: {
    secFilter(val) {
      let sec = Number(val).toFixed(0)
      if (sec < 10) {
        return '0' + sec
      }
      return sec
    },
    minFilter(val) {
      let min = Math.floor(val);
      if (min < 10) {
        return '0' + min
      }
      return min
    }
  },
  mounted() {
    if (this.$route.query.action) {
      this.authWindow = this.$route.query.action
    }
  },
  beforeDestroy() {
    this.clearOtpTimer()
  },
  computed: {
    nameRules() {
      if (this.testRegister || this.authMode !== 'register') {
        return []
      }
      return [
        (v) => !!String(v || '').trim() || this.$t('errors.fillIsRequired'),
      ]
    },
    inputRules() {
      return [
        (v) => {
          if (!v) return this.$t('errors.fillIsRequired')
          let phone = this.toAsciiDigits(v).trim().replaceAll(' ', '')
          if (phone.startsWith('+98')) {
            phone = '0' + phone.substring(3)
          }
          if (phone.startsWith('09') && phone.length === 11 && /^09\d{9}$/.test(phone)) {
            return true
          }
            if (/^09\d*$/.test(phone) && phone.length < 11) return this.$t('authUi.phoneError')
          const phoneNumber = parsePhoneNumberFromString(phone)
          if (phoneNumber && phoneNumber.isValid()) {
            return true
          }
          return this.$t('Notify.signupComponent.phoneNumberError')
        }
      ]
    },
    detectedInputValue() {
      let phone = this.toAsciiDigits(this.loginForm.input || '').replaceAll(' ', '')
      if (phone.startsWith('+98')) {
        phone = '0' + phone.substring(3)
      }
      if (phone.startsWith('09') && phone.length === 11) {
        return phone
      }
      const phoneNumber = parsePhoneNumberFromString(phone)
      if (phoneNumber && phoneNumber.isValid()) {
        const parsedNumber = phoneNumber.number
        if (parsedNumber.startsWith('+98')) {
          return '0' + parsedNumber.substring(3)
        }
        return parsedNumber
      }
      return phone
    },
    maskedPhone() {
      const digits = this.toAsciiDigits(this.detectedInputValue).replace(/\D/g, '')
      if (digits.length < 5) {
        return this.toFaDigits(digits)
      }
      return this.toFaDigits(digits.slice(0, 4) + '••••••' + digits.slice(-1))
    },
    otpResendLabel() {
      if (this.otpTimer > 0) {
        return this.$t('authUi.resendIn', {seconds: this.toFaDigits(this.otpTimer)})
      }
      return this.$t('authUi.resendReady')
    },
    postOtpPasswordConfirmRules() {
      return [
        (v) => !!v || this.$t('Notify.signupComponent.rePasswordRequired'),
        (v) =>
            v === this.postOtpPassword.password ||
            this.$t('Notify.signupComponent.rePasswordCheck'),
      ]
    },
  },
  watch: {
    'loginForm.input'(newVal) {
      if (newVal) {
        let phone = this.toAsciiDigits(newVal).replaceAll(' ', '')
        if (phone.startsWith('+98')) {
          phone = '0' + phone.substring(3)
          this.loginForm.input = phone
        }
      }
    },
    authWindow(val) {
      if (val === 'whatsapp-otp' && !this.testRegister) {
        this.$nextTick(() => this.focusOtp(0))
      }
    },
  },
  methods: {
    toAsciiDigits(value) {
      const map = {
        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
        '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
        '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
      }
      return String(value || '').replace(/[۰-۹٠-٩]/g, (digit) => map[digit] || digit)
    },
    toFaDigits(value) {
      return String(value).replace(/\d/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[digit])
    },
    openTerms(documentId = 'terms') {
      this.legalDocumentId = documentId === 'privacy' ? 'privacy' : 'terms'
      this.showTerms = true
    },
    handleAuthBack() {
      if (this.authWindow === 'whatsapp-otp') {
        this.changePhoneNumber()
        return
      }
      if (this.authWindow === 'post-otp-password') {
        this.authWindow = 'whatsapp-otp'
        return
      }
      if (this.authWindow === 'forgetpassword') {
        this.authWindow = 'login'
        return
      }
      if (window.history.length > 1) {
        this.$router.back()
      }
    },
    changePhoneNumber() {
      this.authWindow = 'login'
      this.otpError = ''
      this.resetOtpDigits()
    },
    resetOtpDigits() {
      this.otpDigits = ['', '', '', '', '', '']
      this.whatsappOtpCode = null
    },
    syncOtpCode() {
      this.whatsappOtpCode = this.otpDigits.join('')
    },
    otpBoxEl(index) {
      const ref = this.$refs['otpBox' + index]
      return Array.isArray(ref) ? ref[0] : ref
    },
    focusOtp(index) {
      const el = this.otpBoxEl(index)
      if (el && typeof el.focus === 'function') {
        el.focus()
        if (typeof el.select === 'function') {
          el.select()
        }
      }
    },
    applyOtpString(value) {
      const digits = this.toAsciiDigits(value).replace(/\D/g, '').slice(0, 6).split('')
      const next = ['', '', '', '', '', '']
      digits.forEach((digit, i) => {
        next[i] = digit
      })
      this.otpDigits = next
      this.syncOtpCode()
      this.otpError = ''
      this.$nextTick(() => {
        this.focusOtp(Math.min(digits.length, 5))
      })
    },
    onOtpInput(index, event) {
      const raw = this.toAsciiDigits(event.target.value).replace(/\D/g, '')
      if (raw.length > 1) {
        this.applyOtpString(raw)
        return
      }
      this.$set(this.otpDigits, index, raw.slice(-1))
      this.syncOtpCode()
      this.otpError = ''
      if (raw && index < 5) {
        this.focusOtp(index + 1)
      }
    },
    onOtpKeydown(index, event) {
      if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
        this.$set(this.otpDigits, index - 1, '')
        this.syncOtpCode()
        this.focusOtp(index - 1)
      }
      if (event.key === 'ArrowLeft' && index > 0) {
        event.preventDefault()
        this.focusOtp(index - 1)
      }
      if (event.key === 'ArrowRight' && index < 5) {
        event.preventDefault()
        this.focusOtp(index + 1)
      }
    },
    onOtpPaste(event) {
      const text = (event.clipboardData && event.clipboardData.getData('text')) || ''
      this.applyOtpString(text)
    },
    setAuthMode(mode) {
      if (this.authMode === mode) {
        return
      }
      this.authMode = mode
      this.nameError = ''
      this.phoneError = ''
      this.termsError = ''
      this.formStatus = ''
    },
    splitRegisterName() {
      const parts = String(this.registerFullName || '').trim().split(/\s+/).filter(Boolean)
      if (!parts.length) {
        return null
      }
      return {
        name: parts[0],
        family: parts.slice(1).join(' '),
      }
    },
    validateNativeLoginForm() {
      this.nameError = ''
      this.phoneError = ''
      this.termsError = ''
      this.formStatus = ''
      if (this.authMode === 'register' && !String(this.registerFullName || '').trim()) {
        this.nameError = this.$t('authUi.nameError')
      }
      const phoneResult = this.inputRules[0](this.loginForm.input)
      if (phoneResult !== true) {
        this.phoneError = phoneResult
      }
      if (this.authMode === 'register' && !this.acceptedTerms) {
        this.termsError = this.$t('authUi.termsError')
      }
      const ok = !this.nameError && !this.phoneError && !this.termsError
      if (!ok) {
        this.formStatus = this.$t('authUi.formIncomplete')
      }
      return ok
    },
    canSendLoginOrRegisterOtp() {
      if (this.testRegister) {
        return this.$refs.loginForm && this.$refs.loginForm.validate()
      }
      return this.validateNativeLoginForm()
    },
    handleLoginFormSubmit(e) {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault()
      }
      this.login()
    },
    loginBy(target) {
      switch (target) {
        case 'google':
          window.location.href = process.env.VUE_APP_BASE_URL + 'auth/social/google';
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.otpTimer != 0) {
          this.otpTimer -= 1
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    resetTimer() {
      clearInterval(this.timer)
      this.otpTimer = 120
    },
    resendWhatsappOtp() {
      this.resetTimer()
      this.resetOtpDigits()
      this.otpError = ''
      this.sendLoginOrRegisterOtp()
    },
    clearOtpTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    completeInlineLogin(resp) {
      const token = resp.data && resp.data.token
      if (!token) {
        return
      }
      this.$store.dispatch('logout', false)
      this.$store.commit('SET_TOKEN', {key: 'token', data: token})
      localStorage.setItem('token', token)
      this.$store.commit('SET_LOGIN')
      this.requesting('auth', 'getProfile').then(() => {
        const profileId = this.$store.getters.getProfile && this.$store.getters.getProfile.id
        if (profileId) {
          this.WebengageSetUserLoggedIn(profileId)
        }
        return this.runUserJourneyNewUserTracking()
      }).then(() => {
        this.$emit('afterLogin')
      })
    },
    isUserJourneyAfterLogin() {
      return this.$route.query.afterLogin === 'userJourney'
    },
    runUserJourneyNewUserTracking() {
      if (!this.isUserJourneyAfterLogin() || !this.loginOrRegisterMeta.is_new_user || this.userJourneyTrkRegistered) {
        return Promise.resolve()
      }

      const profile = this.$store.getters.getProfile
      if (!profile) {
        return Promise.resolve()
      }

      this.userJourneyTrkRegistered = true
      return this.RegisterUserInTrk().then(() => {
        return this.SendEventTrk({
          event_id: 'register_' + Date.now(),
          name: 'register',
          email: profile.email,
          first_name: profile.firstname,
          last_name: profile.lastname,
          payload: {
            from: this.isUserJourneyAfterLogin() ? 'user_journey' : 'login',
          },
        })
      }).then(() => {
        this.SetAttributeTrackerService(profile.email, {
          phone: profile.mobile || profile.cel,
          timezone: profile.tz || this.prepareDefaultTimezone(),
          first_name: profile.firstname,
          auth_id: profile.auth_id,
          last_name: profile.lastname,
        })
      })
    },
    handleNewUserAfterOtp(resp) {
      if (resp.data && resp.data.token) {
        this.$store.dispatch('logout', false)
        this.$store.commit('SET_TOKEN', {key: 'token', data: resp.data.token})
        localStorage.setItem('token', resp.data.token)
        this.$store.commit('SET_LOGIN')
      }
      if (!this.$route.query.afterLogin && !this.$route.query.returnTo) {
        markIntakePending()
      }

      return this.requesting('auth', 'getProfile')
          .then(() => this.runUserJourneyNewUserTracking())
    },
    showPostOtpPasswordForm() {
      this.postOtpPassword = {
        password: null,
        password_confirmation: null,
        passwordType: 'password',
      }
      this.postOtpPasswordConfirm = {passwordType: 'password'}
      this.passwordError = ''
      this.passwordConfirmError = ''
      this.authWindow = 'post-otp-password'
    },
    submitWhatsappOtp() {
      this.syncOtpCode()
      const otp = this.toAsciiDigits(this.whatsappOtpCode).replace(/\D/g, '').slice(0, 6)
      this.whatsappOtpCode = otp
      this.otpError = ''
      if (otp && otp.length === 6) {
        this.$emitEvent('setLoading', true)
        const signupName = !this.testRegister && this.authMode === 'register' ? this.splitRegisterName() : null
        return this.requesting('auth', 'submit-login-or-register-otp', {}, {
          phone: this.detectedInputValue,
          otp,
          ...(signupName || {}),
        }).then((resp) => {
          const msg = (resp && resp.message) ? resp.message : this.$t('Notify.loginSuccess')
          this.$emitEvent('notify', {color: 'green', title: msg, id: 'success_login_whatsapp'});
          if (this.loginOrRegisterMeta.is_new_user) {
            this.clearOtpTimer()
            if (this.testRegister && this.inlineAfterLogin) {
              return this.completeInlineLogin(resp)
            } else {
              return this.handleNewUserAfterOtp(resp).then(() => {
                this.showPostOtpPasswordForm()
              }, () => {
                // Identity was saved by OTP verification; profile loading can retry
                // after the password step without asking for the consumed code again.
                this.showPostOtpPasswordForm()
              })
            }
          } else if (this.inlineAfterLogin) {
            this.completeInlineLogin(resp)
          } else {
            setTimeout(() => {
              const q = loginTokenQuery(this.$route, resp.data.token)
              this.$router.push({name: 'LoginWithToken', params: {lang: this.$route.params.lang || 'fa'}, query: q})
            }, 1000)
          }
        }).catch((error) => {
          const body = error && error.response && error.response.data
          const saveFailed = body && body.data && body.data.code === 'OTP_VERIFICATION_SAVE_FAILED'
          this.otpError = this.$t(saveFailed ? 'authUi.otpSaveRetry' : 'authUi.otpInvalid')
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      } else if (this.testRegister) {
        this.$emitEvent('notify', {color: 'red', title: 'لطفا کد را وارد کنید', id: 'failed_login_whatsapp'});
      } else {
        this.otpError = this.$t('authUi.otpIncomplete')
      }
    },
    sendLoginOrRegisterOtp() {
      if (this.canSendLoginOrRegisterOtp()) {
        this.$emitEvent('setLoading', true)
        const phone = this.detectedInputValue
        const body = {phone}
        if (this.testRegister) {
          body.testRegister = true
        }
        return this.requesting('auth', 'login-or-register', {}, body).then((resp) => {
          const d = (resp && resp.data) ? resp.data : {}
          this.loginOrRegisterMeta = {
            is_new_user: d.is_new_user === true || (this.loginOrRegisterMeta.phone === phone && this.loginOrRegisterMeta.is_new_user),
            phone,
          }
          this.resetOtpDigits()
          this.otpError = ''
          this.authWindow = 'whatsapp-otp'
          this.resetTimer()
          this.startTimer()
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    handlePostOtpPasswordFormSubmit(e) {
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault()
      }
      this.submitPostOtpPassword()
    },
    submitPostOtpPassword() {
      if (!this.testRegister) {
        this.passwordError = ''
        this.passwordConfirmError = ''
        const passwordValue = this.postOtpPassword.password || ''
        for (let i = 0; i < this.passwordRules.length; i++) {
          const result = this.passwordRules[i](passwordValue)
          if (result !== true) {
            this.passwordError = result
            break
          }
        }
        const confirmValue = this.postOtpPassword.password_confirmation || ''
        for (let i = 0; i < this.postOtpPasswordConfirmRules.length; i++) {
          const result = this.postOtpPasswordConfirmRules[i](confirmValue)
          if (result !== true) {
            this.passwordConfirmError = result
            break
          }
        }
        if (this.passwordError || this.passwordConfirmError) {
          return
        }
      } else if (!this.$refs.postOtpPasswordForm || !this.$refs.postOtpPasswordForm.validate()) {
        return
      }
      this.$emitEvent('setLoading', true)
      this.requesting('user', 'setPassword', {}, {
        password: this.postOtpPassword.password,
        password_confirmation: this.postOtpPassword.password_confirmation,
      }).then(() => {
        this.requesting('auth', 'getProfile').then(() => {
          const profileId = this.$store.getters.getProfile && this.$store.getters.getProfile.id
          if (profileId) {
            this.WebengageSetUserLoggedIn(profileId)
          }
          this.$emitEvent('notify', {color: 'green', title: this.$t('Notify.loginSuccess'), id: 'ga_login'});
          return this.runUserJourneyNewUserTracking()
        }).then(() => {
          this.$emit('afterLogin')
        })
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    /**
     *
     * This is Function for change password input type in login or register form, you must declare which form you want to change password input
     *
     * @param {string} model window value of target form
     *
     * */
    changePassType(model) {
      if (model.passwordType == 'password') {
        model.passwordType = 'text'
      } else {
        model.passwordType = 'password'
      }
    },
    /**
     *
     * This is Function for login user in platform. the login process includes the following steps:
     *
     * <br/>
     *
     * <b> 1- validate login form </b><br>
     * <b> 2- send request to /api/v1/login with email and password </b><br>
     * <b> 3- if email and password are correct, send request to /api/v1/profile to get profile of user and store profile and jwt token in localStorage</b><br>
     * <b> 4- notify user with id <i>ga_login</i> and emit <i>afterLogin</i></b><br>
     *
     * */
    login() {
      if (this.canSendLoginOrRegisterOtp()) {
        this.sendLoginOrRegisterOtp()
      }
    },

    /**
     *
     * This is Function for register user in platform. the register process includes the following steps:
     *
     * <br/>
     *
     * <b> 1- validate register form </b><br>
     * <b> 2- send request to /api/v1/register with email , password , re-password , mobile </b><br>
     * <b> 3- If the registration was done without problems, send request to /api/v1/login with email and password to get jwt token</b><br>
     * <b> 4- with token get user profile, send request to /api/v1/profile and store profile in localStorage</b><br>
     * <b> 5- notify user with id <i>ga_signup</i> and emit <i>afterLogin</i></b><br>
     *
     * */
    register() {
      if (this.$refs.registerForm.validate()) {
        let phone = this.phone.replaceAll(' ', '');
        const phoneNumber = parsePhoneNumberFromString(phone);
        if (phoneNumber) {
          if (!phoneNumber.isValid()) {
            this.$emitEvent('notify', 'red', undefined, this.$t('Notify.signupComponent.phoneNumberError'));
            return;
          }
        } else {
          this.$emitEvent('notify', 'red', undefined, this.$t('Notify.signupComponent.phoneNumberError'));
          return;
        }
        this.$emitEvent('setLoading', true)
        let newUser = {
          email: this.registerFrom.email,
          password: this.registerFrom.password,
          password_confirmation: this.registerFrom.password,
          mobile: phoneNumber.number,
        };
        this.requesting('auth', 'register', '', newUser).then(() => {
          this.requesting('auth', 'login', '', {
            email: this.registerFrom.email,
            password: this.registerFrom.password
          }).then(() => {
            this.requesting('auth', 'getProfile').then(() => {

              this.$emitEvent('notify', {
                color: 'green',
                title: this.$t('Notify.signupComponent.success'),
                id: "ga_signup"
              });

              this.WebengageUserRegister(this.$store.getters.getProfile.id, new Date(), this.registerFrom.email, phoneNumber.number)

            }).finally(() => {
              this.$emitEvent('setLoading', false)
              this.$emit('afterLogin')
            })
          })
        }).catch(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },


    /**
     *
     * This is Function for send forget password request in platform. the forget password process includes the following steps:
     *
     * <br/>
     *
     * <b> 1- validate forget password form </b><br>
     * <b> 2- send request to /api/v1/forgotPassword with email</b><br>
     * <b> 3- notify user with id <i>emailNotify</i></b><br>
     * <b> 4- return to login form ></b><br>
     *
     * */
    resetPassword() {
      if (this.$refs.forgetPassword.validate()) {
        this.$emitEvent('setLoading', true)
        this.requesting('auth', 'forgetPassword', '', {
          email: this.forgetPassword.email
        }).then(() => {
          this.$emitEvent('notify', {color: 'green', title: this.$t('sentEmailLink'), id: 'emailNotify'})
          setTimeout(() => {
            this.authWindow = 'login'
          }, 1000)
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
      // forgetPassword
    }
  },
}

</script>

<style>
@media (min-width: 200px ) and (max-width: 600px) {
  
.loginBox {
    width: 90% !important;
    margin: 10px auto !important;
  }
}


.loginMethod {
  /*margin-top: 20px;*/
}

.loginItem {
  display: flex;
  cursor: pointer;
  border: 1px solid #ededed;
  /*padding: 5px;*/
  /*padding-top: 10px;*/
  border-radius: 10px;
  margin-bottom: 20px;
  /*box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px;*/
  box-shadow: 0 3px 5px -3px rgba(0, 0, 0, .3);
  transition: all 0.3s;
}

.loginItem:hover {
  /*border-color: #3cbe8b;*/
  transition: all 0.3s;
  box-shadow: 0 5px 15px -7px rgba(0, 0, 0, .3);
}

.iconItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding: 5px;
}

.titleItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  padding: 5px;
  font-size: 12px;
  margin-right: 30px;
}

.googleBtn {
  width: 100% !important;
}

.loginBox .v-input input {
  //font-family: en-light !important;
}

.loginBox .mobileInput input,
.loginBox .mobileInput input::placeholder {
  //font-family: IRANSans !important;
}

.loginBox {
  width: 414px;
  max-width: calc(100% - 32px);
  padding: clamp(1.5rem, 5vw, 2.5rem) 1.5rem 2rem;
  margin: 0 auto;
  border-radius: var(--r-lg);
  border: 1px solid var(--rb-line-soft);
  background-color: var(--rb-white);
  position: relative;
  box-shadow: none;
}

.rb-auth .loginBox {
  box-shadow: none;
}

.rb-auth-head {
  text-align: right;
  margin-bottom: 1.5rem;
}

.rb-auth-head h1 {
  margin: 0.25rem 0 0;
  color: var(--rb-navy);
  font-size: 1.65rem;
  line-height: 1.35;
  font-weight: 700;
}

.rb-auth-head p {
  margin: 0.55rem 0 0;
  color: var(--rb-muted);
}

.auth-tabs {
  display: flex;
  gap: 0.4rem;
  margin: 0 0 0.5rem;
  padding: 0.3rem;
  background: var(--rb-sand);
  border-radius: 0.85rem;
}

.auth-tabs button {
  flex: 1;
  min-height: 2.6rem;
  border: 0;
  border-radius: 0.65rem;
  background: transparent;
  color: var(--rb-muted);
  cursor: pointer;
  font-weight: 700;
  font-family: inherit;
}

.auth-tabs button[aria-selected="true"] {
  background: white;
  color: var(--rb-navy);
}

.legal-copy {
  text-align: center;
  color: var(--rb-muted);
  font-size: 0.78rem;
  margin: 0 0 0.5rem;
}


.rb-auth .v-text-field fieldset {
  border-color: var(--rb-line) !important;
  border-radius: var(--r-md) !important;
}

.loginBtn {
  width: 100%;
  height: 50px !important;
  font-size: 17px;
  font-weight: bolder;
  border-radius: var(--r-md) !important;
}

.loginBox--psytest {
  overflow: hidden;
}

.psytest-login-logo {
  display: block;
  width: 160px;
  margin: 8px auto 20px;
}

.bottomBack {
  position: absolute;
  bottom: 0px;
  width: 100%;
  right: 0px;
}

.titleAuthWindow {
  font-size: 21px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: rgb(0, 0, 0);
}

.authForm {
  z-index: 999;
}

.descriptionAuthWindow {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: rgb(109, 109, 109);
}

.auth-form-wrap--psytest {
  padding-bottom: 72px;
}
</style>
